import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import Button from '../../../../ui-core/Button/Button';
import { addAosAnimateClassObserver } from '../../../../utils/helpers';

export const FoundationMap = ({ onClick, isLoading }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(
        'LET&lsquo;S DO THIS',
        'isSignup',
        `This course will focus on the 4 key areas of the body that
        need mobility the most:`,
      );
    }
  };
  const elementRef = useRef();
  const pMRef = useRef();
  const aUMRef = useRef();
  const aEMRef = useRef();
  const aLMRef = useRef();
  const bottomRef = useRef();
  useEffect(() => {
    const observer = addAosAnimateClassObserver();
    if (elementRef?.current) {
      observer.observe(elementRef.current);
    }
    if (pMRef?.current) {
      observer.observe(pMRef.current);
    }
    if (aUMRef?.current) {
      observer.observe(aUMRef.current);
    }
    if (aEMRef?.current) {
      observer.observe(aEMRef.current);
    }
    if (aLMRef?.current) {
      observer.observe(aLMRef.current);
    }
    if (bottomRef?.current) {
      observer.observe(bottomRef.current);
    }

    return () => {
      elementRef?.current && observer.unobserve(elementRef?.current);
      pMRef?.current && observer.unobserve(pMRef?.current);
      aUMRef?.current && observer.unobserve(aUMRef?.current);
      aEMRef?.current && observer.unobserve(aEMRef?.current);
      aLMRef?.current && observer.unobserve(aLMRef?.current);
      bottomRef?.current && observer.unobserve(bottomRef?.current);
    };
  }, [
    elementRef?.current,
    pMRef?.current,
    aUMRef?.current,
    aEMRef?.current,
    aLMRef?.current,
    bottomRef?.current,
  ]);
  return (
    <div
      className="course-focus"
      ref={elementRef}
      data-aos="fade-in"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div className="border-box">
        <h2>
          This course will focus on the <em>4 key areas</em> of the body that{' '}
          <em>need mobility</em> the most:
        </h2>
        <ul>
          <li
            ref={pMRef}
            data-aos="fade-in"
            data-aos-delay="50"
            data-aos-duration="1100"
            data-aos-easing="ease-in-out"
          >
            <div className="weeks one">
              <h4>Passive Mobility</h4>
              <span>Week 1</span>
            </div>
          </li>

          <li
            ref={aUMRef}
            data-aos="fade-in"
            data-aos-delay="50"
            data-aos-duration="1300"
            data-aos-easing="ease-in-out"
          >
            <div className="weeks two">
              <h4>Active Unloaded Mobility</h4>
              <span>Week 2</span>
            </div>
          </li>

          <li
            ref={aEMRef}
            data-aos="fade-in"
            data-aos-delay="50"
            data-aos-duration="1500"
            data-aos-easing="ease-in-out"
          >
            <div className="weeks three">
              <h4>Active Eccentric Mobility</h4>
              <span>Week 3</span>
            </div>
          </li>

          <li>
            <div
              className="weeks four"
              ref={aLMRef}
              data-aos="fade-in"
              data-aos-delay="50"
              data-aos-duration="1700"
              data-aos-easing="ease-in-out"
            >
              <h4>Active Loaded Mobility</h4>
              <span>Week 4</span>
            </div>
          </li>
        </ul>
        <div
          ref={bottomRef}
          data-aos="fade-up"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <div className="join-course">
            Join us <em>live</em> each Sunday
          </div>
          <p>
            to review what each of these mobility pillars mean, which would work
            best for your own body and get any of your personal questions
            answered along the journey.
          </p>
        </div>
        <Button
          type="button"
          class="site-btn-stroke mx-auto"
          text="LET&lsquo;S DO THIS"
          onClick={handleClick}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

FoundationMap.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
